import { Check } from 'lucide-react';

interface CheckboxCellProps {
  value: unknown;
}

export function CheckboxCell({ value }: CheckboxCellProps) {
  const checked = value === true || value === 'true' || value === 1;
  if (!checked) return null;
  return <Check className="w-4 h-4 text-success mx-auto" />;
}
